import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { videoIdApprovalActionByAdminFailure, videoIdApprovalActionByAdminSuccess } from '../../actions/manualVerificationActions/videoIdApprovalActionByAdminActions';

function* videoIdApprovalActionByAdmin({ payload }) {
    console.log('====================================');
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.videoIdApprovalActionByAdmin,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("VIDEO_ID_APPROVAL_ACTION_BY_ADMIN_SUCCESS status :", response.data.status);
        console.log("VIDEO_ID_APPROVAL_ACTION_BY_ADMIN_SUCCESS data :", response.data.response);
        console.log("VIDEO_ID_APPROVAL_ACTION_BY_ADMIN_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            videoIdApprovalActionByAdminSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("VIDEO_ID_APPROVAL_ACTION_BY_ADMIN_FAILURE status :", error?.response?.status);
        console.log("VIDEO_ID_APPROVAL_ACTION_BY_ADMIN_FAILURE data:", error?.response?.data);
        console.log("VIDEO_ID_APPROVAL_ACTION_BY_ADMIN_FAILURE error :", error);
        console.log('====================================');
        yield put(videoIdApprovalActionByAdminFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* videoIdApprovalActionByAdminSaga() {
    yield takeLatest(actionTypes.VIDEO_ID_APPROVAL_ACTION_BY_ADMIN_REQUEST, videoIdApprovalActionByAdmin);
}

export default videoIdApprovalActionByAdminSaga;
